"use client";

import { useQuery } from "@tanstack/react-query";
import { me } from "@/lib/api/generated";

export function useAuth() {
  const { data: raw, isLoading, error } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => me(),
    retry: false,
  });

  const user = raw?.user
    ? {
        ...raw.user,
        full_name: `${raw.user.first_name} ${raw.user.last_name}`,
      }
    : null;

  return {
    user,
    organization: raw?.organization ?? null,
    complianceSettings: raw?.compliance_settings ?? null,
    selectedProjectId: raw?.selected_project_id ?? null,
    isLoading,
    isAuthenticated: !!user,
    isAdmin: !!raw?.organization && user?.role === "admin",
    error,
  };
}
